// React import removed
import { SidebarLayout } from '@/layouts/sidebar/SidebarLayout';
import { PageWithLayout } from '@/pages/_app';
import { Helmet } from 'react-helmet-async';
import { TicketDetailsContent } from '@/pageContents/tickets/TicketDetailsContent';
import { Permission } from '@/models/user';

const TicketDetails: PageWithLayout = () => {
    return (
        <>
            <Helmet>
                <title>Tickets Details | Starjack Backoffice</title>
            </Helmet>

            <TicketDetailsContent />
        </>
    );
};

TicketDetails.getLayout = (page) => <SidebarLayout>{page}</SidebarLayout>;
TicketDetails.isProtected = true;
TicketDetails.permissions = [Permission.SUPPORTER];

export default TicketDetails;
